import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AccountSelectionService } from './account-selection.service';
import { Injectable } from '@angular/core';
import { User } from '../model/User';
import { Store } from '@ngrx/store';
import { initUserSelector } from '../store/User/UserSelector';
import { Role } from '../model/Role';

@Injectable({
  providedIn: 'root'
})
export class AccountSelectionResolver implements Resolve<any> {

  constructor(private readonly accountSelectionService: AccountSelectionService,
              private readonly router: Router,
              private readonly userStore: Store<User>) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
    let role = null;
    this.userStore.select(initUserSelector).subscribe((user) => {
      if (user) {
        role = user.userType;
      }
    })
    if (role === Role.ADMINISTRATOR) {
      return this.accountSelectionService.getAdminData();
    } else if (role === Role.GROUP) {
      return this.accountSelectionService.getGroupData();
    }

    this.router.navigateByUrl('login');
  }
}
